import React, { memo } from 'react';
import { useTranslation } from '@dm/i18n';
import { theme } from '../../../index';
import { LogoProps, DEFAULT_IMAGE_SIZE } from '../../Icon/icon';
import LogoIconSvg from '../LogoIconSvg';

const PaybackBrand = (props: LogoProps) => {
  const [t] = useTranslation();
  const {
    id,
    dmId = 'dm-payback-brand',
    pointerEvents = 'none',
    size = DEFAULT_IMAGE_SIZE,
    ...otherProps
  } = props;

  const title = t('ds.logo.paybackBrand.title');
  const viewBox = '0 0 20 20';

  return (
    <LogoIconSvg
      id={id}
      dmId={dmId}
      pointerEvents={pointerEvents}
      size={size}
      title={title}
      viewBox={viewBox}
      {...otherProps}>
      <path
        fill={theme.palette.color5.hex}
        d="M3.4,20C1.5,20,0,18.5,0,16.6V3.4C0,1.5,1.5,0,3.4,0h13.2C18.5,0,20,1.5,20,3.4v13.2c0,1.9-1.5,3.4-3.4,3.4
    L3.4,20L3.4,20z"
      />
      <path
        fill="#0046AA"
        d="M18.8,16.6c0,1.2-1,2.2-2.2,2.2H3.4c-1.2,0-2.2-1-2.2-2.2V3.4c0-1.2,1-2.2,2.2-2.2h13.2c1.2,0,2.2,1,2.2,2.2
        V16.6z"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M5.8,4.1c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8C7.6,4.9,6.8,4.1,5.8,4.1 M5.8,7.3
        C5,7.3,4.3,6.7,4.3,5.8C4.3,5,5,4.3,5.8,4.3S7.3,5,7.3,5.8C7.3,6.7,6.7,7.3,5.8,7.3"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M10,4.1c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8C11.8,4.9,11,4.1,10,4.1 M10,7.3
        c-0.8,0-1.5-0.7-1.5-1.5C8.5,5,9.2,4.3,10,4.3s1.5,0.7,1.5,1.5C11.5,6.7,10.8,7.3,10,7.3"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M14.2,4.1c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8C15.9,4.9,15.1,4.1,14.2,4.1"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M5.8,12.4c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8C7.6,13.2,6.8,12.4,5.8,12.4
         M5.8,15.7c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5C7.3,15,6.7,15.7,5.8,15.7"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M10,12.4c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8C11.8,13.2,11,12.4,10,12.4 M10,15.7
        c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5C11.5,15,10.8,15.7,10,15.7"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M14.2,12.4c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8C15.9,13.2,15.1,12.4,14.2,12.4"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M5.8,8.2c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8C7.6,9,6.8,8.2,5.8,8.2 M5.8,11.5
        c-0.8,0-1.5-0.7-1.5-1.5S5,8.5,5.8,8.5S7.3,9.2,7.3,10C7.3,10.8,6.7,11.5,5.8,11.5"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M10,8.2C9,8.2,8.2,9,8.2,10c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8C11.8,9,11,8.2,10,8.2"
      />
      <path
        fill={theme.palette.color5.hex}
        d="M14.2,8.2c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8C15.9,9,15.1,8.2,14.2,8.2"
      />
    </LogoIconSvg>
  );
};

export default memo(PaybackBrand);
